import "./style.scss"
import {ReactComponent as InfoIcon} from "assets/icons/informationIcon.svg";

const FeesTable = ({data, titles, info}) => {
  return <div className="feesTable">
    <div className="titles">
      <p>{titles[0]}</p>
      <p>{titles[1]}</p>
      <div>
        <p>{titles[2]}</p>
        {info &&
          <InfoIcon/>
        }
      </div>
      <p>{titles[3]}</p>
    </div>
    
    {data.map((item, i) => <div key={i} className="item">
      <p className={"tier " + (item.tier === "VIP"? "gold" : "")}>{item.tier}</p>
      <p className="balance">{item.balance}</p>
      <p className={"required "+ (item.value === "NO" ? "lightGray" : "")}>{item.value}</p>
      <p className="discount">{item.discount}</p>
    </div>)}
  </div>
}

export default FeesTable;